import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Badge } from '../ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Eye, Clock } from 'lucide-react';

const SupportLogTab = ({ supportLogs }) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2"><Eye className="h-5 w-5 text-amber-600" />Support Activity Log</CardTitle>
      <CardDescription>All actions taken by Support/Builder users are logged here for your visibility</CardDescription>
    </CardHeader>
    <CardContent>
      {supportLogs.length === 0 ? (
        <div className="text-center py-12 text-[#666666]"><Clock className="h-12 w-12 mx-auto mb-3 text-gray-300" /><p>No support activity logged yet</p><p className="text-sm mt-1">Actions will appear here when a Support/Builder user logs in or makes changes</p></div>
      ) : (
        <div className="overflow-x-auto">
          <Table>
            <TableHeader><TableRow className="bg-[#F5F5F5]"><TableHead>Timestamp</TableHead><TableHead>User</TableHead><TableHead>Action</TableHead><TableHead>Details</TableHead><TableHead>IP Address</TableHead></TableRow></TableHeader>
            <TableBody>
              {supportLogs.map((log) => (
                <TableRow key={log.id}>
                  <TableCell className="text-sm">{new Date(log.timestamp).toLocaleString()}</TableCell>
                  <TableCell><div><p className="font-medium">{log.user_name}</p><p className="text-xs text-[#666666]">{log.user_email}</p></div></TableCell>
                  <TableCell><Badge className={log.action === 'LOGIN' ? 'bg-amber-100 text-amber-800' : log.action === 'SETTINGS_UPDATE' ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'}>{log.action}</Badge></TableCell>
                  <TableCell className="text-sm text-[#666666] max-w-xs truncate">{JSON.stringify(log.details)}</TableCell>
                  <TableCell className="text-sm font-mono">{log.ip_address}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </CardContent>
  </Card>
);

export { SupportLogTab };
